import { createSelector } from 'reselect';
import { FieldFeature } from 'types';
import { AppState } from '../store/types/Store';

export const getCountryFeatures = (state: AppState) => state.user.countryFeatures;
const getFeatureKey = (_state: AppState, key: FieldFeature) => key;

export const isFeatureAvailableInCountry = createSelector(
  [getCountryFeatures, getFeatureKey],
  (countryFeatures = [], feature) => countryFeatures.includes(feature)
);
